import {
  startOfDay,
  endOfDay,
  subDays,
  startOfMonth,
  endOfMonth,
  subMonths,
  subYears,
  startOfYear,
  endOfYear,
} from "date-fns";

export type ShortcutKey =
  | "today"
  | "yesterday"
  | "last7"
  | "thisMonth"
  | "lastMonth"
  | "lastQuarter"
  | "last6Months"
  | "last12Months"
  | "lastYear"
  | "thisYear";

export interface ShortcutConfig {
  key: ShortcutKey;
  label: string;
  getRange: () => [Date, Date];
}

const endOfOfDay = (date: Date) => endOfDay(date);

export const SHORTCUT_CONFIGS: Record<ShortcutKey, ShortcutConfig> = {
  today: {
    key: "today",
    label: "ui.dataRange.shortcuts.today",
    getRange: () => [startOfDay(new Date()), endOfOfDay(new Date())],
  },
  yesterday: {
    key: "yesterday",
    label: "ui.dataRange.shortcuts.yesterday",
    getRange: () => {
      const yesterday = subDays(new Date(), 1);
      return [startOfDay(yesterday), endOfDay(yesterday)];
    },
  },
  last7: {
    key: "last7",
    label: "ui.dataRange.shortcuts.last7",
    getRange: () => [startOfDay(subDays(new Date(), 7)), endOfDay(new Date())],
  },
  thisMonth: {
    key: "thisMonth",
    label: "ui.dataRange.shortcuts.thisMonth",
    getRange: () => [startOfMonth(new Date()), endOfMonth(new Date())],
  },
  lastMonth: {
    key: "lastMonth",
    label: "ui.dataRange.shortcuts.lastMonth",
    getRange: () => {
      const lastMonth = subMonths(new Date(), 1);
      return [startOfMonth(lastMonth), endOfMonth(lastMonth)];
    },
  },
  lastQuarter: {
    key: "lastQuarter",
    label: "ui.dataRange.shortcuts.lastQuarter",
    getRange: () => [
      startOfDay(subMonths(new Date(), 3)),
      endOfDay(new Date()),
    ],
  },
  last6Months: {
    key: "last6Months",
    label: "ui.dataRange.shortcuts.last6Months",
    getRange: () => [
      startOfDay(subMonths(new Date(), 6)),
      endOfDay(new Date()),
    ],
  },
  last12Months: {
    key: "last12Months",
    label: "ui.dataRange.shortcuts.last12Months",
    getRange: () => [
      startOfDay(subMonths(new Date(), 12)),
      endOfDay(new Date()),
    ],
  },
  lastYear: {
    key: "lastYear",
    label: "ui.dataRange.shortcuts.lastYear",
    getRange: () => {
      const lastYearDate = subYears(new Date(), 1);
      return [startOfYear(lastYearDate), endOfYear(lastYearDate)];
    },
  },
  thisYear: {
    key: "thisYear",
    label: "ui.dataRange.shortcuts.thisYear",
    getRange: () => [startOfYear(new Date()), endOfYear(new Date())],
  },
};
